import { format } from "date-fns";
import { getFormattedTimeForGetCategoriesCall } from "./getFormattedTimeForGetCategoriesCall";

export type BuildEuropcarAvailabilityDateParamsInput = {
  pickupDate: Date;
  returnDate: Date;
  pickupHours: number;
  pickupMinutes: number;
  returnHours: number;
  returnMinutes: number;
};

export type EuropcarAvailabilityDateParams = {
  pickupDate: string;
  pickupTime: string;
  returnDate: string;
  returnTime: string;
};

/**
 * Builds Europcar API date/time params for availability and booking calls.
 * Formats: dates YYYYMMDD, times HHMM.
 */
export const buildEuropcarAvailabilityDateParams = ({
  pickupDate,
  returnDate,
  pickupHours,
  pickupMinutes,
  returnHours,
  returnMinutes
}: BuildEuropcarAvailabilityDateParamsInput): EuropcarAvailabilityDateParams => ({
  pickupDate: format(new Date(pickupDate), "yyyyMMdd"),
  pickupTime: getFormattedTimeForGetCategoriesCall(pickupHours, pickupMinutes),
  returnDate: format(new Date(returnDate), "yyyyMMdd"),
  returnTime: getFormattedTimeForGetCategoriesCall(returnHours, returnMinutes)
});
